// Forms and modals (event modal, plant modals, todo modals, recurring config).
const forms = {
  en: {
    // Create/Manage plant modals
    'forms.createPlant': 'Create plant',
    'forms.creating': 'Creating...',
    'forms.managePlants': 'Manage Plants',
    'forms.plantCategory': 'Plant Category',
    'forms.plantCategoryPlaceholder': 'e.g. Tomatoes',
    'forms.plantVariety': 'Plant Variety',
    'forms.plantVarietyPlaceholder': 'e.g. Cherry',
    'forms.category': 'Category',
    'forms.plantName': 'Name',
    'forms.varietyOptional': 'Variety (optional)',
    'forms.chooseIcon': 'Choose icon',
    'forms.chooseAnIcon': 'Choose an icon',
    'forms.create': 'Create',
    'forms.editPlant': 'Edit plant',
    'forms.deletePlant': 'Delete plant',
    'forms.deletePlantTitle': 'Delete "{name}"?',
    'forms.noPlantsYet': 'No plants yet.',
    'forms.deletePlantConfirm': 'Past events will keep the reference to this plant.',
    'forms.enterCategoryError': 'Please enter a plant category.',
    'forms.signInToCreatePlants': 'Please sign in to create plants.',
    'forms.plantCreated': 'Plant created successfully!',
    'forms.plantCreateFailed': 'Failed to create plant. Please try again.',
    'forms.plantUpdated': 'Plant updated successfully!',
    'forms.plantUpdateFailed': 'Failed to update plant. Please try again.',
    'forms.plantDeleted': 'Plant deleted.',
    'forms.plantDeleteFailed': 'Failed to delete plant. Please try again.',

    // Manage to-do modal
    'forms.manageTodo': 'Manage to-do',
    'forms.newTodo': 'New to-do',
    'forms.noSavedTodos': 'No saved to-dos yet.',

    // Event modal
    'forms.newEvent': 'New event',
    'forms.editEvent': 'Edit event',
    'forms.deleteEvent': 'Delete event',
    'forms.deleteTodo': 'Delete TO DO',
    'forms.update': 'Update',
    'forms.updating': 'Updating...',
    'forms.saving': 'Saving...',
    'forms.todo': 'To-do',
    'forms.selectTodo': 'Select a to-do',
    'forms.plant': 'Plant',
    'forms.plants': 'Plants',
    'forms.selectPlant': 'Select plant',
    'forms.noPlantsCreate': "You don't have any plants - create a plant",
    'forms.date': 'Date',
    'forms.description': 'Description',
    'forms.addDescription': 'Add a description',
    'forms.updateEventMissingId': 'Cannot update event - missing ID. Please try refreshing the page.',
    'forms.saveEventFailed': 'Failed to save event. Please try again.',
    'forms.eventAlreadyOnDay': '"{name}" is already on {date}.',

    // Recurring config section
    'forms.recurringEvent': 'This is a recurring event',
    'forms.repeatEveryDays': 'Repeat every (days)',
    'forms.howRecurringEnds': 'How recurring ends',
    'forms.seriesEnds': 'Series ends',
    'forms.afterOccurrences': 'After occurrences',
    'forms.onDate': 'On date',
    'forms.onDateInclusive': 'On a date (inclusive)',
    'forms.numberOfOccurrences': 'Number of occurrences',
    'forms.occurrencesHelp': 'Total times this event occurs, including the first one',
    'forms.repeatUntil': 'Repeat until',
    'forms.repeatUntilHelp': 'Last occurrence falls on this date or earlier',
    'forms.recurringInvalidInterval': 'Enter a number of days from 1 to 365.',
    'forms.recurringInvalidCount': 'Enter a whole number of occurrences of at least 1.',
    'forms.recurringEndBeforeStart': 'The end date must be on or after the event date.',
    'forms.recurringWillCreate': 'This will create {count} events.',
  },
  lt: {
    // Create/Manage plant modals
    'forms.createPlant': 'Sukurti augalą',
    'forms.creating': 'Kuriama...',
    'forms.managePlants': 'Tvarkyti augalus',
    'forms.plantCategory': 'Augalo kategorija',
    'forms.plantCategoryPlaceholder': 'pvz. Pomidorai',
    'forms.plantVariety': 'Augalo veislė',
    'forms.plantVarietyPlaceholder': 'pvz. Vyšniniai',
    'forms.category': 'Kategorija',
    'forms.plantName': 'Pavadinimas',
    'forms.varietyOptional': 'Veislė (nebūtina)',
    'forms.chooseIcon': 'Pasirinkite piktogramą',
    'forms.chooseAnIcon': 'Pasirinkite piktogramą',
    'forms.create': 'Sukurti',
    'forms.editPlant': 'Redaguoti augalą',
    'forms.deletePlant': 'Ištrinti augalą',
    'forms.deletePlantTitle': 'Ištrinti „{name}“?',
    'forms.noPlantsYet': 'Dar nėra augalų.',
    'forms.deletePlantConfirm': 'Ankstesni įvykiai išsaugos nuorodą į šį augalą.',
    'forms.enterCategoryError': 'Prašome įvesti augalo kategoriją.',
    'forms.signInToCreatePlants': 'Prašome prisijungti, kad galėtumėte kurti augalus.',
    'forms.plantCreated': 'Augalas sėkmingai sukurtas!',
    'forms.plantCreateFailed': 'Nepavyko sukurti augalo. Bandykite dar kartą.',
    'forms.plantUpdated': 'Augalas sėkmingai atnaujintas!',
    'forms.plantUpdateFailed': 'Nepavyko atnaujinti augalo. Bandykite dar kartą.',
    'forms.plantDeleted': 'Augalas ištrintas.',
    'forms.plantDeleteFailed': 'Nepavyko ištrinti augalo. Bandykite dar kartą.',

    // Manage to-do modal
    'forms.manageTodo': 'Tvarkyti darbus',
    'forms.newTodo': 'Naujas darbas',
    'forms.noSavedTodos': 'Dar nėra išsaugotų darbų.',

    // Event modal
    'forms.newEvent': 'Naujas įvykis',
    'forms.editEvent': 'Redaguoti įvykį',
    'forms.deleteEvent': 'Ištrinti įvykį',
    'forms.deleteTodo': 'Ištrinti darbą',
    'forms.update': 'Atnaujinti',
    'forms.updating': 'Atnaujinama...',
    'forms.saving': 'Išsaugoma...',
    'forms.todo': 'Darbas',
    'forms.selectTodo': 'Pasirinkite darbą',
    'forms.plant': 'Augalas',
    'forms.plants': 'Augalai',
    'forms.selectPlant': 'Pasirinkite augalą',
    'forms.noPlantsCreate': 'Neturite jokių augalų – sukurkite augalą',
    'forms.date': 'Data',
    'forms.description': 'Aprašymas',
    'forms.addDescription': 'Pridėkite aprašymą',
    'forms.updateEventMissingId': 'Nepavyko atnaujinti įvykio – trūksta ID. Pabandykite perkrauti puslapį.',
    'forms.saveEventFailed': 'Nepavyko išsaugoti įvykio. Bandykite dar kartą.',
    'forms.eventAlreadyOnDay': '„{name}“ jau yra {date}.',

    // Recurring config section
    'forms.recurringEvent': 'Tai pasikartojantis įvykis',
    'forms.repeatEveryDays': 'Kartoti kas (dienų)',
    'forms.howRecurringEnds': 'Kaip baigiasi pasikartojimas',
    'forms.seriesEnds': 'Serija baigiasi',
    'forms.afterOccurrences': 'Po kartų',
    'forms.onDate': 'Iki datos',
    'forms.onDateInclusive': 'Nurodytą dieną (imtinai)',
    'forms.numberOfOccurrences': 'Pasikartojimų skaičius',
    'forms.occurrencesHelp': 'Kiek kartų iš viso įvyks šis įvykis, įskaitant pirmąjį',
    'forms.repeatUntil': 'Kartoti iki',
    'forms.repeatUntilHelp': 'Paskutinis pasikartojimas įvyks šią dieną arba anksčiau',
    'forms.recurringInvalidInterval': 'Įveskite dienų skaičių nuo 1 iki 365.',
    'forms.recurringInvalidCount': 'Įveskite bent 1 sveiką pasikartojimų skaičių.',
    'forms.recurringEndBeforeStart': 'Pabaigos data turi būti įvykio dieną arba vėliau.',
    'forms.recurringWillCreate': 'Bus sukurta įvykių: {count}.',
  },
};

export default forms;
